import { render, staticRenderFns } from "./RoleConfig.vue?vue&type=template&id=8c63d19a&scoped=true&"
import script from "./RoleConfig.vue?vue&type=script&lang=js&"
export * from "./RoleConfig.vue?vue&type=script&lang=js&"
import style0 from "./RoleConfig.vue?vue&type=style&index=0&id=8c63d19a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c63d19a",
  null
  
)

export default component.exports